export default {
  map_unavailable: 'Nie udało się załadować mapy. Odśwież stronę i spróbuj ponownie.',
  stubs: {
    name: 'Strefa dostaw {{number}}',
  },
  buttons: {
    add_new_zone: 'Dodaj nową strefę',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować stref dostaw',
  },
};
